import { Link } from 'react-router-dom';

import React from 'react';

export const NavDisconnectedUser = () => {
  return (
    <div className='nav-right'>
      <Link className='nav-item' to={'/login'}>
        Sign In
      </Link>
      <Link className='nav-item' to={'/register'}>
        Create Account
      </Link>
    </div>
  );
};
